import { render, staticRenderFns } from "./RecentEventsModal.container.vue?vue&type=template&id=092bcf73&"
import script from "./RecentEventsModal.container.vue?vue&type=script&lang=ts&"
export * from "./RecentEventsModal.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports